<template>
	<fieldset v-if="id && formCode && name" class="itv-input-term">
		<input
			class="visually-hidden"
			type="checkbox"
			:id="`${id}-${formCode}`"
			:name="name"
			:value="value"
			ref="term"
			@change="$emit('changeValue', this.$refs.term.checked, id)"
		/>
		<div class="itv-input-term__term-label-wrap">
			<label class="itv-input-term__term-label" :for="`${id}-${formCode}`">{{
				label
			}}</label>
			<span class="itv-input-term__term-link" @click.prevent="termModalShow">{{
				link
			}}</span>
			<span class="itv-input-term__term-text"> в соответствии с </span>
			<a
				class="itv-input-term__term-link"
				href="/upload/documents/personal_data_process.pdf"
				target="_blank"
				>политикой</a
			>
		</div>
	</fieldset>
</template>

<script>
export default {
	name: 'InputTerm',
	props: {
		formCode: {
			type: String,
			default: 'form',
		},
		value: {
			type: String,
			default: 's1',
		},
		id: {
			type: String,
			default: 'TERM',
		},
		name: {
			type: String,
			default: 'agreement',
		},
	},
	data() {
		return {
			label: 'Согласен (-на) на ',
			link: 'обработку персональных данных',
		}
	},

	methods: {
		termModalShow() {
			this.$emit('showTerm')
		},
	},
}
</script>
